export default __webpack_public_path__ + "static/media/person_1@2x.3533a79f.png";